var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    attrs: {
      id: "swap-application-confirmation-modal",
      "loaders-disabled": "",
    },
    on: {
      hidden: function ($event) {
        return _vm.$emit("hidden")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("application.swapApplicant.confirmSwapTitle")) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.$t("application.swapApplicant.confirmSwap", {
                    applicantFullName: _vm.selectedApplicantName,
                  })
                ) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "simple-button",
              {
                attrs: { loading: _vm.loading },
                on: { click: _vm.handleConfirmClick },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t("application.swapApplicant.confirmSwapButtonText")
                    ) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }